<p-toast position="bottom-right" ></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<h4 class="form-title">{{'page.' + this.transPartKey + '.title'|translate}}</h4>
<app-cc-form #ccForm [transPartKey]="transPartKey"
             [loading]="formLoading" [submitted]="formSubmitted"
             [formConfig]="formConfig" [(formRecord)]="formRecord"
             [globalErrorMessage]="''"
></app-cc-form>
<div class="text-right">
    <button pButton type="button" (click)="cancel()"
            [disabled]="formLoading||!hasModification"
            [label]="'common.dialog.cancel' | translate"
            class="p-button-warning p-button-sm mr-10"></button>
    <button pButton type="button" (click)="reset()"
            [disabled]="formLoading||!hasAdjustments"
            [label]="'common.dialog.reset' | translate"
            class="p-button-danger p-button-sm mr-10"></button>
    <button pButton type="button" (click)="save()"
            [disabled]="formLoading||!hasModification"
            [label]="'common.dialog.apply' | translate"
            class="p-button-success p-button-sm"></button>
</div>
